import { buildFileUrl } from '../apiConfig';

export const DEFAULT_AVATAR_URL = '/images/avatar.png';

export function getAvatarUrl(avatarPath) {
  if (!avatarPath) {
    return DEFAULT_AVATAR_URL;
  }

  return buildFileUrl(avatarPath);
}
